const __WEBPACK_NAMESPACE_OBJECT__ = require("@performant-software/semantic-components");